
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { useNavigate } from "react-router-dom";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import HostelEdit from "../AdminStudentHostelFee/HostelEdit"
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const navigate = useNavigate();
  const [selectedStudent, setSelectedStudent] = useState({
    name: "",
    barcode: "",
    admissionNo: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });
  const [sectionId, setSectionId] = useState(null);
  const [classId, setClassId] = useState(null);
  //  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [transportData, setTransportData] = useState([]);
  const [showStudentSearchModal, setShowStudentSearchModal] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [studentTransportDetails, setStudentTransportDetails] = useState(null);
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
 const [show, setShow] = useState(false);
 
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const fromClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

const handleClear = () => {
  setStudentName("");
    setStudentId("");
  setClassId(null);
  setSectionId(null);
  setTransportData([]); // Clear table data
};

  // Slice data for pagination
  const offset = currentPage * itemsPerPage;
  const currentData = transportData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(transportData.length / itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  // const handleSelectStudent = (selectedStudent) => {
  //   const fullName = [
  //     selectedStudent.studentBasicDetails.first_name || "",
  //     selectedStudent.studentBasicDetails.middle_name || "",
  //     selectedStudent.studentBasicDetails.last_name || "",
  //   ]
  //     .filter(Boolean)
  //     .join(" ");

  //   // Set studentId when selecting a student (we will use this for the search)
  //   setStudentId(selectedStudent.studentBasicDetails.id || "");
  //   setStudentName(fullName); // Set student name for display (not used for search)
  //   setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
  //   setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

  //   handleCloseModal();
  // };

const handleSelectStudent = (selectedStudent) => {
  // Build full name from top-level fields
  const fullName = [
    selectedStudent.studentname || "", // use studentname from API
  ]
    .filter(Boolean)
    .join(" ");

  // Set studentId (use studentId from API)
  setStudentId(selectedStudent.studentId || "");

  // Set student name for display
  setStudentName(fullName);

  // Set classId and sectionId
  setClassId(selectedStudent.classId || null);
  setSectionId(selectedStudent.sectionId || null);

  handleCloseModal();
};

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) {
          console.error("Missing orgId or branchId in local storage");
          return;
        }

        const response = await fetch(
          `/api/Transport/routemasterlist/${orgId}/${branchId}/`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch routes");
        }

        const data = await response.json();
        const options = data.map((route) => ({
          value: route.id,
          label: route.transport_name,
        }));

        setRoutes(options);
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    };

    fetchRoutes();
  }, []);

  const handleSearch = async () => {
    try {
      const academicSessionId = localStorage.getItem("academicSessionId") || "";
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!academicSessionId || !orgId || !branchId) {
        console.error("Mandatory fields are missing.");
        return;
      }

      const queryParams = new URLSearchParams({
        academic_year_id: academicSessionId,
        org_id: orgId,
        branch_id: branchId,
      });

      if (studentId) queryParams.append("student_id", studentId);
      if (classId) queryParams.append("class_id", classId);
      if (sectionId) queryParams.append("section_id", sectionId);

      const response = await fetch(
        `${ApiUrl.apiurl}HOSTEL/GetStudentHostelList/?${queryParams.toString()}`
      );

      const data = await response.json();

      if (data.message === "success") {
        setTransportData(data.data);
      } else {
        console.error("Failed to fetch transport data: ", data.message);
        setTransportData([]);
      }
    } catch (error) {
      console.error("Error fetching transport data:", error);
      setTransportData([]);
    }
  };

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);

  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  const handleOpenModal = async (student) => {
    setShowModal(true);
    setSelectedStudent(student);

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}HOSTEL/HostelDetailsRetereiveByStudent/${student.student_id}`
      );
      const data = await response.json();
      if (data.message === "success") {
        setStudentTransportDetails(data.data);
      } else {
        console.error("Failed to fetch transport details:", data.message);
        setStudentTransportDetails(null);
      }
    } catch (error) {
      console.error("Error fetching transport details:", error);
      setStudentTransportDetails(null);
    }
  };

  const isHostelAvailed = (value) => {
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return ["true", "1", "yes", "y"].includes(normalized);
    }
    return false;
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
    setStudentTransportDetails(null);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT HOSTEL
              </p>
              <div className="row mb-2 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2 mt-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-3 mt-3">
                      <div className="col-12 col-md-3 ">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleShow}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <SelectStudentFeeModal
                        show={show}
                        handleClose={handleClose}
                        onSelectStudent={handleSelectStudent}
                      />

                      <div className="col-md-3 mb-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId
                            ) || null
                          } // Match the selected class
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null
                            ); // Debugging
                            setSectionId(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Student Name</th>
                        <th>Barcode</th>
                        <th>Roll No</th>
                        <th>Class</th>
                        <th>Section</th>

                        <th>Father Name</th>
                        <th>Mother Name</th>
                        <th>Hostel Availed</th>
                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.length > 0 ? (
                        currentData.map((student, index) => (
                          <tr key={student.student_id}>
                            <td>{offset + index + 1}</td>
                            <td>{student.studentname}</td>
                            <td>{student.barcode || "N/A"}</td>
                            <td>{student.rollNo || "N/A"}</td>
                            <td>{student.className}</td>
                            <td>{student.sectionName}</td>
                            <td>{student.fatherName || "N/A"}</td>
                            <td>{student.motherName || "N/A"}</td>
                            <td>
                              {isHostelAvailed(
                                student.hostel_avail ?? student.hostel_availed
                              )
                                ? "Yes"
                                : "No"}
                            </td>

                            <td>
                              <a
                                href="#"
                                className="text-primary text-decoration-none"
                                // onClick={() =>
                                //   handleOpenStudentSearchModal(studentId)
                                // }

                                onClick={() => handleOpenModal(student)}
                              >
                                Edit
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <HostelEdit
                    show={showModal}
                    handleClose={handleCloseModal}
                    studentData={selectedStudent}
                    transportDetails={studentTransportDetails}
                    routes={routes}
                    onSaveSuccess={handleSearch}
                  />
                  {transportData.length > itemsPerPage && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "pagination justify-content-center mt-3"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
